<template>
    <div class="main">
        <div>
            <div class="header">
                <div class="left">入住率</div>
                <!-- <div
                    :class="{ isActive: a.two, right: true }"
                    @click="chooseCheckA"
                >
                    本年
                </div>
                <div
                    :class="{ isActive: a.one, right: true }"
                    @click="chooseCheckB"
                >
                    本月
                </div> -->
                <div class="go">单位：间</div>
            </div>
            <div
                style="
                    width: 100%;
                    height: calc(100% - 30px);
                    padding-bottom: 10px;
                    position: relative;
                "
            >
                <Spin fix v-if="loading1"></Spin>
                <e-charts v-else :options="options1" autoresize />
            </div>
        </div>
        <div>
            <div class="header">
                <div class="left">客户转化率</div>
                <div
                    :class="{ isActive: b.two, right: true }"
                    @click="chooseCheckC"
                >
                    本年
                </div>
                <div
                    :class="{ isActive: b.one, right: true }"
                    @click="chooseCheckD"
                >
                    本月
                </div>
                <div class="go">单位：人</div>
            </div>
            <div
                style="
                    width: 100%;
                    height: calc(100% - 30px);
                    padding-bottom: 10px;
                    position: relative;
                "
            >
                <Spin fix v-if="loading2"></Spin>
                <e-charts v-else :options="options2" autoresize />
            </div>
        </div>
        <div>
            <div class="header">
                <div class="left">交租拖欠率</div>
                <div
                    :class="{ isActive: c.two, right: true }"
                    @click="chooseCheckF"
                >
                    本年
                </div>
                <div
                    :class="{ isActive: c.one, right: true }"
                    @click="chooseCheckG"
                >
                    本月
                </div>
                <div class="go">单位：个</div>
            </div>
            <div
                style="
                    width: 100%;
                    height: calc(100% - 30px);
                    padding-bottom: 10px;
                    position: relative;
                "
            >
                <Spin fix v-if="loading3"></Spin>
                <e-charts v-else :options="options3" autoresize />
            </div>
        </div>
        <div>
            <div class="header">
                <div class="left">收入占比</div>
                <div
                    :class="{ isActive: d.two, right: true }"
                    @click="chooseCheckH"
                >
                    本年
                </div>
                <div
                    :class="{ isActive: d.one, right: true }"
                    @click="chooseCheckJ"
                >
                    本月
                </div>
                <div class="go">单位：元</div>
            </div>
            <div
                style="
                    width: 100%;
                    height: calc(100% - 30px);
                    padding-bottom: 10px;
                    position: relative;
                "
            >
                <Spin fix v-if="loading4"></Spin>
                <e-charts v-else :options="options4" autoresize />
            </div>
        </div>
    </div>
</template>

<script>
import {
    liveRateStatistic,
    cusStatistic,
    payRentStatistic,
    incomeRateStatistic,
} from '@/api/ems-stats'
import PieMixin from '@/views/common/m-chart-pie'
export default {
    name: 'operate-footer',
    mixins: [PieMixin],
    data() {
        return {
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            a: {
                one: true,
                two: false,
            },
            b: {
                one: true,
                two: false,
            },
            c: {
                one: true,
                two: false,
            },
            d: {
                one: true,
                two: false,
            },
            liveRateStatistic: {
                dimension: '1', // 入住率
                rentCount: '',
                scheduledCount: '',
                vacantCount: '',
                per: '',
            },
            cusStatistic: {
                dimension: '1', // 客户转化率
                intentCus: '', // 意向
                hisCus: '', // 历史
                rentCus: '', // 在租
                per: '',
            },
            payRentStatistic: {
                dimension: '1', //  交租拖欠率
                payCount: '',
                unPayCount: '',
                per: '',
            },
            incomeRateStatistic: {
                dimension: '1', //  收入占比
                expend: '',
                income: '',
                per: '',
            },
        }
    },
    methods: {
        chooseCheckA() {
            this.a.two = true
            this.a.one = false
            this.liveRateStatistic.dimension = '3'
            this.getLive()
        },
        chooseCheckB() {
            this.a.two = false
            this.a.one = true
            this.liveRateStatistic.dimension = '1'
            this.getLive()
        },
        getLive() {
            this.loading1 = true
            liveRateStatistic(this.liveRateStatistic.dimension)
                .then((res) => {
                    this.liveRateStatistic.rentCount = Number(
                        res.data.rentCount
                    )
                    this.liveRateStatistic.scheduledCount = Number(
                        res.data.scheduledCount
                    )
                    this.liveRateStatistic.vacantCount = Number(
                        res.data.vacantCount
                    )
                    if (this.liveRateStatistic.rentCount !== 0) {
                        this.liveRateStatistic.per =
                            (
                                (this.liveRateStatistic.rentCount /
                                    (this.liveRateStatistic.rentCount +
                                        this.liveRateStatistic.scheduledCount +
                                        this.liveRateStatistic.vacantCount)) *
                                100
                            ).toFixed() + '%'
                    } else {
                        this.liveRateStatistic.per = '0' + '%'
                    }
                })
                .finally(() => {
                    this.loading1 = false
                })
        },
        chooseCheckC() {
            this.b.two = true
            this.b.one = false
            this.cusStatistic.dimension = '3'
            this.getCus()
        },
        chooseCheckD() {
            this.b.two = false
            this.b.one = true
            this.cusStatistic.dimension = '1'
            this.getCus()
        },
        getCus() {
            this.loading2 = true
            cusStatistic(this.cusStatistic.dimension)
                .then((res) => {
                    this.cusStatistic.hisCus = Number(res.data.hisCus)
                    this.cusStatistic.intentCus = Number(res.data.intentCus)
                    this.cusStatistic.rentCus = Number(res.data.rentCus)
                    if (this.cusStatistic.rentCus !== 0) {
                        this.cusStatistic.per =
                            (
                                (
                                    this.cusStatistic.rentCus /
                                    (this.cusStatistic.rentCus +
                                        this.cusStatistic.intentCus +
                                        this.cusStatistic.hisCus)
                                ).toFixed(2) * 100
                            ).toFixed() + '%'
                    } else {
                        this.cusStatistic.per = '0' + '%'
                    }
                })
                .finally(() => {
                    this.loading2 = false
                })
        },
        chooseCheckF() {
            this.c.two = true
            this.c.one = false
            this.payRentStatistic.dimension = '3'
            this.getPay()
        },
        chooseCheckG() {
            this.c.two = false
            this.c.one = true
            this.payRentStatistic.dimension = '1'
            this.getPay()
        },
        getPay() {
            this.loading3 = true
            payRentStatistic(this.payRentStatistic.dimension)
                .then((res) => {
                    this.payRentStatistic.payCount = Number(res.data.payCount)
                    this.payRentStatistic.unPayCount = Number(
                        res.data.unPayCount
                    )
                    if (this.payRentStatistic.unPayCount !== 0) {
                        this.payRentStatistic.per =
                            (
                                (
                                    this.payRentStatistic.unPayCount /
                                    (this.payRentStatistic.payCount +
                                        this.payRentStatistic.unPayCount)
                                ).toFixed(2) * 100
                            ).toFixed() + '%'
                    } else {
                        this.payRentStatistic.per = '0' + '%'
                    }
                })
                .finally(() => {
                    this.loading3 = false
                })
        },
        chooseCheckH() {
            this.d.two = true
            this.d.one = false
            this.incomeRateStatistic.dimension = '3'
            this.getIncome()
        },
        chooseCheckJ() {
            this.d.two = false
            this.d.one = true
            this.incomeRateStatistic.dimension = '1'
            this.getIncome()
        },
        getIncome() {
            this.loading4 = true
            incomeRateStatistic(this.incomeRateStatistic.dimension)
                .then((res) => {
                    let list = res.data.list
                    list.forEach((i) => {
                        if (i.flowType == 1) {
                            this.incomeRateStatistic.income = i.amount / 100
                        } else if (i.flowType == 2) {
                            this.incomeRateStatistic.expend = i.amount / 100
                        }
                    })
                    if (
                        this.incomeRateStatistic.income &&
                        this.incomeRateStatistic.income !== 0
                    ) {
                        this.incomeRateStatistic.per =
                            (
                                (
                                    this.incomeRateStatistic.income /
                                    (this.incomeRateStatistic.income +
                                        this.incomeRateStatistic.expend)
                                ).toFixed(2) * 100
                            ).toFixed() + '%'
                    } else {
                        this.incomeRateStatistic.per = '0' + '%'
                    }
                })
                .finally(() => {
                    this.loading4 = false
                })
        },
    },
    computed: {
        options1() {
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                legend: {
                    orient: 'horizontal',
                    top: 10,
                    left: 'center',
                    itemWidth: 15,
                    data: ['租住中', '预订中', '退租 / 空置'],
                },
                title: {
                    text: this.liveRateStatistic.per,
                    left: 'center',
                    top: '55%',
                    textStyle: {
                        color: '#27D9C8',
                        fontSize: 24,
                        align: 'center',
                    },
                },
                series: [
                    {
                        name: '入住率',
                        type: 'pie',
                        radius: ['45%', '55%'],
                        center: ['50%', '60%'],
                        labelLine: {
                            normal: {
                                length: 5,
                            },
                        },

                        data: [
                            {
                                value: this.liveRateStatistic.rentCount,
                                name: '租住中',
                            },
                            {
                                value: this.liveRateStatistic.scheduledCount,
                                name: '预订中',
                            },
                            {
                                value: this.liveRateStatistic.vacantCount,
                                name: '退租 / 空置',
                            },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                        color: [
                            'rgb(44,141,240)',
                            'rgb(0,197,203)',
                            'rgb(215,215,215)',
                        ],
                    },
                ],
            }
        },

        options2() {
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                legend: {
                    orient: 'horizontal',
                    top: 10,
                    left: 'center',
                    itemWidth: 15,
                    data: ['在租客户', '意向客户', '历史客户'],
                },
                title: {
                    text: this.cusStatistic.per,
                    left: 'center',
                    top: '55%',
                    textStyle: {
                        color: '#27D9C8',
                        fontSize: 24,
                        align: 'center',
                    },
                },
                series: [
                    {
                        name: '客户转化率',
                        type: 'pie',
                        radius: ['45%', '55%'],
                        center: ['50%', '60%'],
                        labelLine: {
                            normal: {
                                length: 5,
                            },
                        },
                        data: [
                            {
                                value: this.cusStatistic.rentCus,
                                name: '在租客户',
                            },
                            {
                                value: this.cusStatistic.intentCus,
                                name: '意向客户',
                            },
                            {
                                value: this.cusStatistic.hisCus,
                                name: '历史客户',
                            },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                        color: [
                            'rgb(44,141,240)',
                            'rgb(0,197,203)',
                            'rgb(215,215,215)',
                        ],
                    },
                ],
            }
        },
        options3() {
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                legend: {
                    orient: 'horizontal',
                    top: 10,
                    itemWidth: 15,
                    left: 'center',
                    data: ['已交租', '未交租'],
                },
                title: {
                    text: this.payRentStatistic.per,
                    left: 'center',
                    top: '55%',
                    textStyle: {
                        color: '#27D9C8',
                        fontSize: 24,
                        align: 'center',
                    },
                },
                series: [
                    {
                        name: '交租拖欠率',
                        type: 'pie',
                        radius: ['45%', '55%'],
                        center: ['50%', '60%'],
                        labelLine: {
                            normal: {
                                length: 5,
                            },
                        },
                        data: [
                            {
                                value: this.payRentStatistic.payCount,
                                name: '已交租',
                            },
                            {
                                value: this.payRentStatistic.unPayCount,
                                name: '未交租',
                            },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                        color: ['rgb(44,141,240)', 'rgb(215,215,215)'],
                    },
                ],
            }
        },
        options4() {
            return {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                legend: {
                    orient: 'horizontal',
                    top: 10,
                    left: 'center',
                    itemWidth: 15,
                    data: ['收入', '支出'],
                },
                title: {
                    text: this.incomeRateStatistic.per,
                    left: 'center',
                    top: '55%',
                    textStyle: {
                        color: '#27D9C8',
                        fontSize: 24,
                        align: 'center',
                    },
                },
                series: [
                    {
                        name: '收入占比',
                        type: 'pie',
                        radius: ['45%', '55%'],
                        center: ['50%', '60%'],
                        labelLine: {
                            normal: {
                                length: 5,
                            },
                        },
                        data: [
                            {
                                value: this.incomeRateStatistic.income || 0,
                                name: '收入',
                            },
                            {
                                value: this.incomeRateStatistic.expend || 0,
                                name: '支出',
                            },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                        color: ['rgb(44,141,240)', 'rgb(215,215,215)'],
                    },
                ],
            }
        },
    },
    created() {
        Promise.all([
            this.getLive(),
            this.getCus(),
            this.getPay(),
            this.getIncome(),
        ])
    },
}
</script>

<style lang="less" scoped>
.main {
    display: flex;
    & > div {
        height: 300px;
        width: 25%;
        // flex-grow: 1;
        background: rgb(255, 255, 255);
        margin-right: 25px;
        box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }
    & div:nth-child(4) {
        margin-right: 0;
    }
}
.isActive {
    color: rgb(44, 141, 240);
}

.header {
    height: 25px;
    font-size: 12px;
    margin-bottom: 10px;
    position: relative;
    & .right {
        float: right;
        margin-top: 10px;
        margin-right: 18px;
        cursor: pointer;
    }
    & .left {
        float: left;
        margin-top: 10px;
        margin-left: 18px;
        font-size: 14px;
    }
}
.go {
    position: absolute;
    top: 70px;
    left: 18px;
    color: rgb(153, 153, 153);
    font-size: 12px;
}
</style>
